import * as yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { HTTP_ENDPOINTS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  clinicId: yup.number().required(),
  apiKey: yup.string().required(),
});

export function useQualiphyEnrollClinicMutation(options = {}) {
  return useMutation((dto) => {
    const req = requestSchema.validateSync(dto, {
      strict: true,
    });
    return http.post(HTTP_ENDPOINTS.qualiphy.enrollClinic(), {
      clinic_id: req.clinicId,
      api_key: req.apiKey,
    });
  }, options);
}
